import {WlIntegerInput} from "./integerInput.component";

export * from './integerInput.component';
export default WlIntegerInput;

customElements.define('wl-integer-input', WlIntegerInput);
